/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CopyDocumentResponseData,
  CopyDocumentResponseDataFromJSON,
  CopyDocumentResponseDataFromJSONTyped,
  CopyDocumentResponseDataToJSON
} from './CopyDocumentResponseData'

/**
 *
 * @export
 * @interface CopyDocumentResponse
 */
export interface CopyDocumentResponse {
  /**
   *
   * @type {number}
   * @memberof CopyDocumentResponse
   */
  status: number
  /**
   *
   * @type {CopyDocumentResponseData}
   * @memberof CopyDocumentResponse
   */
  data: CopyDocumentResponseData
}

export function CopyDocumentResponseFromJSON(json: any): CopyDocumentResponse {
  return CopyDocumentResponseFromJSONTyped(json, false)
}

export function CopyDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyDocumentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: CopyDocumentResponseDataFromJSON(json['data'])
  }
}

export function CopyDocumentResponseToJSON(value?: CopyDocumentResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CopyDocumentResponseDataToJSON(value.data)
  }
}
